import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TriggerGroupEntity } from './trigger-group.entity';

@Entity('_trigger_group_category')
export class TriggerGroupCategoryEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@OneToMany(
		() => TriggerGroupEntity,
		(triggerGroup) => triggerGroup.fkTriggerGroupCategory,
		{},
	)
	public triggerGroups!: Array<TriggerGroupEntity>;
}
